/* eslint-disable react-hooks/exhaustive-deps */
import clsx from "clsx";
import Button from "components/common_components/Button";
import Card from "components/common_components/Card";
import Icon from "components/common_components/Icon";
import React, { useContext, useEffect, useState } from "react";
import { hasElements } from "utils/arrays";
import PropTypes from "prop-types";
import { TextField } from "@material-ui/core";
import Link from "components/common_components/Link";
import Status from "components/common_components/Status";
import FormsContext from "../FormsContext";

const Forms = ({ visible, onClick, onBackClick }) => {
    const [filter, setFilter] = useState("");

    const { resources, addFormState } = useContext(FormsContext);

    const [filteredForms, setFilteredForms] = useState([]);

    const onFilterChange = (e) => {
        setFilter(e.target.value);
    };

    useEffect(() => {
        if (addFormState.form) {
            setFilteredForms([addFormState.form]);
        } else {
            if (hasElements(resources.forms)) {
                let formsByCategory = resources.forms;
                if (addFormState.category) {
                    formsByCategory = resources.forms.filter((form) => form.category.id === addFormState.category.id);
                }
                if (filter) {
                    setFilteredForms(
                        formsByCategory.filter(
                            (form) =>
                                form.code.toLowerCase().includes(filter.toLowerCase()) ||
                                form.issuer.issuer.toLowerCase().includes(filter.toLowerCase())
                        )
                    );
                    return;
                }
                setFilteredForms(formsByCategory);
            } else {
                setFilteredForms([]);
            }
        }
    }, [filter, resources.forms, addFormState.form, addFormState.category]);

    const onBackClickHandler = () => {
        onBackClick();
    };

    const onClearFilter = () => setFilter("");

    return (
        <div
            className={clsx("layout current-forms", {
                visible: visible,
                invisible: !visible,
            })}
        >
            {visible && (
                <>
                    {addFormState.category && (
                        <Button outline secondary small onClick={onBackClickHandler}>
                            <span>{addFormState.category.category}</span>
                            <Icon name="cancel" color="secondary" size="xs" />
                        </Button>
                    )}
                    {filter && (
                        <Button outline secondary small onClick={onClearFilter}>
                            <span>Clear filter</span>
                            <Icon name="cancel" color="secondary" size="xs" />
                        </Button>
                    )}
                    <hr />
                    {!addFormState.form && (
                        <>
                            <small>
                                <i>Select the form</i>
                            </small>
                            <TextField type="text" placeholder="Search form..." value={filter} onChange={onFilterChange} />
                        </>
                    )}
                    <div className="forms">
                        {filteredForms.map((form) => (
                            <Card
                                title={
                                    <>
                                        {form.code} {form.isCurrent ? <Status id="active" /> : <Status id="oldVersion" />}
                                    </>
                                }
                                key={form.id}
                                onClick={() => onClick(form)}
                                disabled={addFormState.form === form}
                            >
                                <div>
                                    <Link href={form.officialUrl} target="_blank">
                                        <span>{form.issuer.issuer}</span>
                                        <Icon name="open-new-tab" color="primary" size="sm" />
                                    </Link>
                                    <div className="form-version">
                                        <span>{`Version ${form.version}`} </span>
                                        <span></span>
                                    </div>
                                    <div className="form-expires">
                                        <span>{`Expires ${form.expiresString}`}</span>
                                    </div>
                                </div>
                                {addFormState.form === form && <Icon name="rounded-check" color="extra" size="xlg" />}
                                {addFormState.form !== form && (
                                    <Icon name="arrow" color="secondary" size="xs" style={{ transform: "rotate(180deg)" }} />
                                )}
                            </Card>
                        ))}
                    </div>
                </>
            )}
        </div>
    );
};

Forms.propTypes = {
    forms: PropTypes.array,
    category: PropTypes.shape({
        id: PropTypes.string,
        category: PropTypes.string,
        description: PropTypes.string,
        parentCategory: PropTypes.shape({
            id: PropTypes.string,
            category: PropTypes.string,
        }),
    }),
    visible: PropTypes.bool,
    onClick: PropTypes.func,
    onBackClick: PropTypes.func,
    selected: PropTypes.object,
};

Forms.defaultProps = {
    forms: [],
    category: null,
    visible: false,
    onClick: () => {},
    onBackClick: () => {},
    selected: null,
};

export default Forms;
